import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';
import { parse } from 'handlebars';
import Select from 'react-select';

const EmployeeService = () => {
  const [totalEmployees, setTotalEmployee] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [show, setShow] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
   const [totalItems, setTotalItems] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const [ roleToDelete,setRoleToDelete] = useState('');
  const [roles, setRoles] = useState([]);
  const [activeemployee, setactiveemployee] = useState([]);
  const [employeeserviceList, setemployeeserviceList] = useState([]);
  const history = useHistory();
  const [employeeid, setEmployeeid] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedRoleName, setSelectedRoleName] = useState([]);
  const [currentRoleId, setCurrentRoleId] = useState(null);
  const [employeestatus, setemployeeStatus] = useState(null);
  const [errors, setErrors] = useState({});
  const [selectAllServices, setSelectAllServices] = useState(false);


  useEffect(() => {
    fetchEmployeeData();
    fetchRoleData();
    fetchactiveemployee();
}, [currentPage]);

const fetchactiveemployee = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/employee/get-active-employees`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      
      setactiveemployee(response.data);
      
      setIsLogin(false);
  } catch (error) {
    setactiveemployee([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};

const fetchRoleData = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
     const response = await axios.get(`${var_api}/api/sub-category-master/get`, { 
          headers: {
              'Authorization': `${token}`
          }
      });
      
      setRoles(response.data);
      
      setIsLogin(false);
  } catch (error) {
      setRoles([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};

const groupEmployeesByName = (employeeList) => {
  const groupedEmployees = employeeList.reduce((acc, employee) => {
    if (!acc[employee.emp_name]) {
      acc[employee.emp_name] = {
        ...employee,
        services: [],
      };
    }
    acc[employee.emp_name].services.push(employee.service_name);
    return acc;
  }, {});

  return Object.values(groupedEmployees).map(employee => ({
    ...employee,
    service_name: employee.services.join(', '),
  }));
};

const fetchEmployeeData = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
    const response = await axios.get(`${var_api}/api/employee-services/get`, {
      headers: {
        Authorization: `${token}`,
      },
    });

    const groupedData = groupEmployeesByName(response.data);
    setemployeeserviceList(groupedData);

    setIsLogin(false);
  } catch (error) {
    setemployeeserviceList([]);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
  }
};

const validateForm = () => {
  const newErrors = {};

  if (!employeeName) newErrors.employeeName = 'Employee Name is required';
  if (selectedRole.length === 0) newErrors.selectedRole = 'At least one service is required';

  return newErrors;
};

const handleOpenConfirmation = (employeeId) => {
    setRoleToDelete(employeeId);
    setShow(true);
};

const handleCloseConfirmation= ()=>{
    setShow(false)
  };
  
const resetForm = () => {
    setEmployeeName('');
    setEmployeeid('');
    setSelectedRole([]);
    setSelectedRoleName([]);
    setSelectAllServices(false);
};

const handleDelete = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
        await axios.delete(`${var_api}/api/employee-services/delete/${roleToDelete}`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        console.log('Role deleted successfully!');
        fetchEmployeeData();
        handleCloseConfirmation();
        setIsLogin(false);
    } catch (error) {
        console.error('Error deleting role:', error);
        if (error.response && error.response.status === 401) {
            history.push('/signin');
        }
    }
};

const handleRoleChange = (selectedOptions) => {
  if (!selectedOptions) {
    setSelectedRole([]);
    setSelectedRoleName([]);
    setSelectAllServices(false);
    return;
  }

  // Check if "Select All" option is selected
  const selectAllOption = selectedOptions.find(option => option.value === 'all');
  
  if (selectAllOption) {
    // Select all services except the "Select All" option itself
    const allServices = roles.map(role => ({
      value: role.id,
      label: role.service_name
    }));
    setSelectedRole(allServices.map(service => service.value));
    setSelectedRoleName(allServices.map(service => service.label));
    setSelectAllServices(true);
  } else {
    // Handle regular multiple selection
    setSelectedRole(selectedOptions.map(option => option.value));
    setSelectedRoleName(selectedOptions.map(option => option.label));
    setSelectAllServices(false);
  }
};

const createEmployee = async () => {
  const validationErrors = validateForm();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    Swal.fire({
      icon: 'warning',
      title: 'Validation Error',
      text: 'Please fill all required fields',
    });
    return;
  }

  if (selectedRole.length === 0) {
    Swal.fire({
      icon: 'warning',
      title: 'No Services Selected',
      text: 'Please select at least one service',
    });
    return;
  }

  const token = localStorage.getItem('token');
  const payloads = selectedRole.map((serviceId, index) => ({
    emp_id: parseInt(employeeid),
    emp_name: employeeName,
    service_id: parseInt(serviceId),
    service_name: selectedRoleName[index],
  }));

  setIsLogin(true);
  try {
    // Send all services in multiple API calls
    const promises = payloads.map(payload =>
      axios.post(`${var_api}/api/employee-services/post`, payload, {
        headers: { Authorization: `${token}` },
      })
    );

    await Promise.all(promises);
    
    console.log('All services added successfully!');
    fetchEmployeeData();
    resetForm();
    
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: `Added ${selectedRole.length} service(s) to ${employeeName} successfully!`,
    });
  } catch (error) {
    console.error('Error submitting data:', error);
    Swal.fire({
      icon: 'error',
      title: 'Submission Failed',
      text: error.response?.data?.message || 'There was an error submitting the data.',
    });
  } finally {
    setIsLogin(false);
  }
};

const handleemployeeName = (selectedOption) => {
  if (selectedOption) {
    setEmployeeid(selectedOption.value);
    setEmployeeName(selectedOption.label);
  } else {
    setEmployeeid('');
    setEmployeeName('');
  }
};

const handleSearchInput = (e) => {
  setSearchQuery(e.target.value);
  setCurrentPage(1);
};

const filteredEmployees = Array.isArray(employeeserviceList) && employeeserviceList.filter(employee => {
  const searchLower = searchQuery.toLowerCase();
  const matchesServices = employee.services?.some(service => 
    service.toString().toLowerCase().includes(searchLower)
  );

  return (
    (employee.emp_name?.toString().toLowerCase().includes(searchLower) || "") ||
    matchesServices
  );
});

const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

const handlePageChange = (pageNumber) => {
  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
  if (pageNumber > totalPages) {
    setCurrentPage(totalPages);
  } else {
    setCurrentPage(pageNumber);
  }
};

const handleRemoveService = (employeeId, serviceName) => {
  setemployeeserviceList((prev) =>
    prev.map((employee) =>
      employee.id === employeeId
        ? {
            ...employee,
            services: employee.services.filter((service) => service !== serviceName),
          }
        : employee
    )
  );
};

return(
  <>
    {isLogin && <Loader />}
    <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
      <Navbar.Brand href="#home">
        <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mx-auto">
          <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
            EMPLOYEE SERVICES
          </Nav.Link>
        </Nav>
        <Nav className="ms-auto">
          <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
            <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
              <i className="bi bi-house"></i> Go to home
            </button>
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
    <br/>
    <br/>
    <br/>
    <br/>
    <div style={{margin:"auto",padding:"20px"}}>
      <Row>
        <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
          <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
              <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>
                {editMode ? 'Edit Employee Service' : 'Create Employee Service'}
              </h5>
              <Form onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="formBasicName" className="mt-3">
                  <Form.Label>Employee Name</Form.Label>
                  <Select
                    value={
                      employeeid
                        ? { value: employeeid, label: employeeName }
                        : null
                    }
                    onChange={handleemployeeName}
                    options={activeemployee.map((employee) => ({
                      value: employee.id,
                      label: employee.name,
                    }))}
                    placeholder="Select Employee"
                    isClearable
                  />
                  {errors.employeeName && <p style={{ color: 'red' }}>{errors.employeeName}</p>}
                </Form.Group>

                <Form.Group controlId="formBasicRole" className="mt-3">
                  <Form.Label>Service Name</Form.Label>
                  <Select
                    value={
                      selectedRole.length > 0
                        ? roles
                            .filter(role => selectedRole.includes(role.id))
                            .map(role => ({
                              value: role.id,
                              label: role.service_name
                            }))
                        : []
                    }
                    onChange={handleRoleChange}
                    options={[
                      { value: 'all', label: 'Select All Services' },
                      ...roles.map((role) => ({
                        value: role.id,
                        label: role.service_name,
                      }))
                    ]}
                    placeholder="Select Service(s)"
                    isMulti
                    isClearable
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                  />
                  <small className="text-muted">
                    {selectAllServices 
                      ? `All ${roles.length} services selected` 
                      : selectedRole.length > 0 
                        ? `${selectedRole.length} service(s) selected` 
                        : 'Select one or more services'}
                  </small>
                  {errors.selectedRole && <p style={{ color: 'red' }}>{errors.selectedRole}</p>}
                </Form.Group>

                <Button
                  variant="primary"
                  type="button"
                  className="mt-3"
                  style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                  onClick={createEmployee}
                >
                  Submit
                </Button>{" "}

                <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                  Reset
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
          <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
            <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>
              Employee Service List 
              <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}>
                <Form.Control 
                  type="text" 
                  placeholder="Search..."  
                  onChange={handleSearchInput}
                  value={searchQuery}
                />
              </span>
            </h5>
                    
            <Table responsive className="mt-3">
              <thead>
                <tr>
                  <th>S.No</th> 
                  <th>Employee Name</th>
                  <th>Service Name</th>
                </tr>
              </thead>
              <tbody>
                {paginatedFilteredEmployees.length > 0 ? (
                  paginatedFilteredEmployees.map((employee, index) => (
                    <tr key={employee.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{employee.emp_name}</td>
                      <td>
                        <div className="d-flex flex-wrap">
                          {employee.services.map((service, serviceIndex) => (
                            <div
                              key={serviceIndex}
                              className="card m-1"
                              style={{
                                position: "relative",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "30px",
                                boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
                                justifyContent:"space-between",
                                margin: "5px",
                                height: "auto",
                                width: "auto",
                              }}
                            >
                              <span style={{ fontSize: "0.9rem", marginRight:"20px" }}>{service}</span>
                              <button
                                className="btn-close"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "5px",
                                  fontSize: "0.7rem",
                                  color: "white",
                                  backgroundColor: "red",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  marginLeft:"10px"
                                }}
                                onClick={() => handleOpenConfirmation(employee.id)}
                                aria-label="Close"
                              >
                              </button>
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">No data available</td>
                  </tr>
                )}
              </tbody>
            </Table>
            
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={itemsPerPage}
              totalItemsCount={filteredEmployees.length}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              itemClass="page-item"
              linkClass="page-link"
              innerClass="pagination justify-content-end"
              activeClass="active-pagination"
            />
          </Card>
        </Col>
      </Row>
    </div>
    
    <Modal
      show={show}
      onHide={handleCloseConfirmation}
      backdrop="static"
      keyboard={false}
      size="md"
      style={{ borderRadius: '20px' }}
    >
      <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
        <Modal.Title style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
        </div>
        <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
          Close
        </Button>{' '} 
        <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
          Confirm
        </Button>
      </Modal.Body>
    </Modal>
  </>
)
}

export default EmployeeService;